<template>
	<div class="complaint-page">
		<time-num></time-num>
		<div class="content">
			<div class="topText">
				<span>请观看一段视频</span>
				<span>了解宠主主诉</span>
			</div>
			<div class="content-video">
				<div class="main-box">
					<!-- <video
            poster="./../../assets/home/cover.png"
            id="video"
            ref="videoPlay"
            class="videos"
            controls
            x5-playsinline="true"
            x5-video-orientation="portraint"
            x-webkit-airplay="allow"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="false"
            playsinline
            webkit-playsinline
            controlslist="noplaybackrate nodownload"
            :custom-cache="false"
            preload="auto"
            src="../../assets/treat/1.mp4"
          ></video> -->
					<video poster="./../../assets/home/cover.png" id="video" ref="videoPlay" class="videos" controls
						x5-playsinline="true" x5-video-orientation="portraint" x-webkit-airplay="allow"
						x5-video-player-type="h5" x5-video-player-fullscreen="false" playsinline webkit-playsinline
						controlslist="noplaybackrate nodownload" :custom-cache="false" preload="auto"
						:src="treatmentLists.video"></video>
				</div>
			</div>
			<div class="broadcast">
				<div class="broadcast-item" v-show="item.flag" v-for="item in videoLisr" :key="item.title">
					<div @click="handleVideoPlay(item)" class="broadcast-bcgrd">
						<img :src="item.img" alt />
					</div>
					<div>{{ item.title }}</div>
				</div>

				<!-- rateList -->
				<div class="broadcast-item">
					<div @click="handleRate()" class="broadcast-rebroadcast">
						{{ rateDataLabel }}
					</div>
					<div>倍速</div>
				</div>

				<div class="broadcast-item" v-show="item.flag" v-for="item in rebroadcast" :key="item.title">
					<div @click="handleVideoPlay(item)" class="broadcast-rebroadcast">
						<img :src="item.img" alt />
					</div>
					<div>{{ item.title }}</div>
				</div>
			</div>
		</div>
		<div class="complaintFooter">
			<!-- <div class="nextquestionactive" @click="$router.replace('/treat/Catalog')">
				<img class="next1" src="./../../assets/home/previous.png"></img>上一步
			</div> -->
			<div v-show="!nextBtn&&treatmentLists.video" class="disableb-text">
				请先完整观看视频，方可进入下一步
			</div>
			<div v-show="nextBtn||!treatmentLists.video" @click="handleNextBtn" class="text">下一步</div>
		</div>
		<van-popup v-model="showPicker" position="bottom">
			<van-picker show-toolbar :columns="rateList" @cancel="showPicker = false" @confirm="onConfirm" />
		</van-popup>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import {
		mapMutations,
		mapState
	} from "vuex";
	import MiXin from "../mixins/index";
	import TimeNum from "../mixins/timeNum";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		components: {
			MiXin,
			TimeNum,
		},
		data() {
			return {
				rateData: 5.0,
				rateDataLabel: "1.0x",
				showPicker: false,
				treatmentLists: null,
				complaintclientHeight: true,
				nextBtn: false,
				complaintObj: {},
				rebroadcast: [{
					id: 3,
					flag: true,
					title: "回看",
					img: require("./../../assets/treat/rebroadcast.png"),
				}, ],
				rateList: ["0.5x", "1.0x", "1.5x", "2.0x"],
				videoLisr: [{
						id: 1,
						flag: true,
						title: "播放",
						img: require("./../../assets/treat/start.png"),
					},
					{
						id: 1,
						flag: false,
						title: "暂停",
						img: require("./../../assets/treat/suspend.png"),
					},
				],
			};
		},
		computed: {
			...mapState("visualExamination", [
				"selectPosition",
				"contentObj",
				"overIndex",
				"treatmentList",
				//步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
				"treatmentEcho",
			]),
			...mapState("microscope", ["examDetailId"]),
		},
		created() {
			this.treatmentLists = this.treatmentList;
		},
		mounted() {
			if (document.documentElement.clientHeight >= 1038) {
				this.complaintclientHeight = false;
			} else {
				this.complaintclientHeight = true;
			}
			document.addEventListener(
				"touchmove",
				(e) => {
					if (e.target.className.indexOf("video-dialog") > -1) {
						e.preventDefault();
					}
				}, {
					passive: false
				}
			);

			//开始
			this.$refs.videoPlay.addEventListener("play", this.handlePlay);

			//暂停
			this.$refs.videoPlay.addEventListener("pause", this.handlePause);

			//结束
			this.$refs.videoPlay.addEventListener("ended", this.handleVideoEnd);
		},

		methods: {
			...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
			handleRate() {
				this.showPicker = true;
			},
			onConfirm(value) {
				this.rateDataLabel = value;
				if (value === "0.5x") {
					this.rateData = 0.5;
				} else if (value === "1.0x") {
					this.rateData = 1;
				} else if (value === "1.5x") {
					this.rateData = 1.5;
				} else if (value === "2.0x") {
					this.rateData = 2;
				}
				this.$refs.videoPlay.playbackRate = this.rateData;
				this.showPicker = false;
			},
			//下一步
			handleNextBtn() {
				this.VISUAL_EXAMINATION({
					key: "treatModleTime",
					value: true
				});
				if (this.treatmentLists.scoreSheet) {
					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					const parmes = {
						paperId: this.treatmentList.id,
						details: newArr,
					};
					submitExamCommitSingerAnswer({
						backendAnswers: JSON.stringify(parmes),
						paperId: this.treatmentList.id,
						questionId: '-207',
						answers: JSON.stringify({
							detail: this.detail,
							detailsz2: this.detailsz2,
							detail3: this.detail3,
							detailstepPre3: this.detailstepPre3,
							detail4: this.detail4,
							detail5: this.detail5,
							treatmentEcho: this.treatmentEcho
						}),
						extractDetailId: this.examDetailId,
					}).then((response) => {
						this.$router.replace("/treat/pruritus");
					});

				} else {
					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					const parmes = {
						paperId: this.treatmentList.id,
						details: newArr,
					};
					submitExamCommitSingerAnswer({
						backendAnswers: JSON.stringify(parmes),
						paperId: this.treatmentList.id,
						questionId: '-208',
						answers: JSON.stringify({
							detail: this.detail,
							detailsz2: this.detailsz2,
							detail3: this.detail3,
							detailstepPre3: this.detailstepPre3,
							detail4: this.detail4,
							detail5: this.detail5,
							treatmentEcho: this.treatmentEcho
						}),
						extractDetailId: this.examDetailId,
					}).then((response) => {
						this.$router.replace({
							path: "/treat/medicalrecord",
							query: {
								num: 1.1
							},
						});
					});

				}
			},

			//开始
			handlePlay() {
				this.$refs.videoPlay.play();
				this.videoLisr[0].flag = false;
				this.videoLisr[1].flag = true;
			},

			//暂停
			handlePause() {
				this.$refs.videoPlay.pause();
				this.videoLisr[0].flag = true;
				this.videoLisr[1].flag = false;
			},

			//结束
			handleVideoEnd() {
				this.nextBtn = true;
				this.videoLisr[0].flag = true;
				this.videoLisr[1].flag = false;
			},

			//视频播放
			handleVideoPlay(v) {
				const that = this;
				switch (v.id) {
					case 1:
						if (this.$refs.videoPlay.paused) {
							this.$refs.videoPlay.play();
							this.videoLisr[0].flag = false;
							this.videoLisr[1].flag = true;
						} else {
							this.$refs.videoPlay.pause();
							this.videoLisr[0].flag = true;
							this.videoLisr[1].flag = false;
						}
						var elevideo = this.$refs.videoPlay;
						elevideo.addEventListener(
							"ended",
							function() {
								//结束
								that.nextBtn = true;
								that.videoLisr[0].flag = true;
								that.videoLisr[1].flag = false;
							},
							false
						);
						break;
					case 3:
						this.$refs.videoPlay.currentTime = 0;
						this.$refs.videoPlay.play();
						break;
					default:
						break;
				}
			},
		},
	};
</script>
<style lang="less" scoped>
	.complaint-page {
		width: 100%;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: relative;

		.content {
			width: 100%;
			height: 100%;
			box-sizing: border-box;
			display: flex;
			flex: 1;
			flex-direction: column;
			padding: 20px 50px 102px 50px;
			box-sizing: border-box;

			.topText {
				text-align: center;
				display: flex;
				flex-direction: column;
				justify-content: center;
				font-size: 35px;
				font-weight: bold;
				color: #ffffff;
			}

			.content-video {
				width: 100%;
				height: 545px;
				background: rgba(255, 255, 255, 0.3);
				box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
				border: 2px solid #ffffff;
				border-radius: 60px;
				margin-top: 40px;
				padding: 19px 23px;
				box-sizing: border-box;

				.main-box {
					width: 100%;
					height: 507px;
					display: flex;
					justify-content: center;
					align-items: center;
					background: #ffffff;
					border-radius: 48px;
				}

				.videos {
					width: 100%;
					height: 75%;
				}
			}

			.broadcast {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 79px;
				box-sizing: border-box;
				padding: 0px 141px;

				.broadcast-item {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					font-size: 25px;
					font-weight: 500;
					color: #ffffff;

					.broadcast-bcgrd {
						width: 91px;
						height: 91px;
						border-radius: 50%;
						background-color: #ab3b91;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-bottom: 18px;

						img {
							width: 33px;
						}
					}

					.broadcast-rebroadcast {
						width: 91px;
						height: 91px;
						border-radius: 50%;
						background-color: #ab3b91;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-bottom: 18px;

						img {
							width: 48px;
						}
					}
				}
			}
		}

		.complaintFooter {
			position: fixed;
			left: 0;
			bottom: 0;
			width: 100%;
			height: 183px;
			border-radius: 60px 60px 0px 0px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-around;

			.text {
				width: 274px;
				height: 85px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				border-radius: 42px;
				text-align: center;
				line-height: 85px;
				font-size: 30px;
				font-weight: 500;
				color: #ffffff;
			}

			.disableb-text {
				padding: 0px 15px;
				height: 85px;
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				border-radius: 42px;
				text-align: center;
				line-height: 85px;
				font-size: 30px;
				font-weight: 500;
				background: #ccc;
				color: #000;
			}
		}
	}

	.nextquestionactive {
		background: linear-gradient(138.51deg, rgba(0, 187, 177, 1) 0%, rgba(0, 80, 137, 1) 79.86%, rgba(171, 59, 127, 1) 100%);
		font-size: 32px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 214px;
		height: 88px;
		border-radius: 100px;
	}

	.next1 {
		width: 28px;
		height: 24px;
		margin-right: 16px;
	}
</style>